import { Injectable, computed, inject, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from './Global';

@Injectable({
  providedIn: 'root'
})

export class UserService {
  public userData = signal(null)
  public userPhoto = signal<string | null>(null)
  public sharingIdentity = signal(null)
  public sharingEntity = signal({})
  public sharingEntities = signal<[]>([])
  public sharingLanguage = signal({})
  public sharingRole = signal({})
  public sharingMenu = signal<[]>([])
  public sharingMenuPath = signal({})

  private _http = inject(HttpClient)
  private url = Global.url_user

  processUserData(userData?: any) {
    if (userData) this.userData.set(userData)
  }

  processUserPhoto(arrayBuffer?: ArrayBuffer) {
    if(!arrayBuffer) return null
    const url = this.arrayBufferToUrl(arrayBuffer);
    this.userPhoto.set(url)
    return
  }

  private arrayBufferToUrl(arrayBuffer: ArrayBuffer): string {
    const array = new Uint8Array(arrayBuffer);
    const blob = new Blob([array], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }

  changeEntitySelected(entidad: any): Observable<any> {
    let params = entidad;
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this._http.patch(this.url + 'update-entity-selected', params, { headers: headers })
  }

  getUsers(search?: string): Observable<any> {
    return this._http.get(this.url + `users/${search}`);
  }
  createUser(user: any) {
    return this._http.post(this.url + `users`, user);
  }

  updateUser(user: any) {
    return this._http.patch(this.url + `users`, user);
  }


  getAllMenus() {
    return this._http.get(this.url + `menus`);
  }

  updateMenu(menu: any) {
    return this._http.put(this.url + `menus`, menu);
  }
  createMenu(menu: any) {
    return this._http.post(this.url + `menus`, menu);
  }
  deleteMenu(id: string) {
    return this._http.delete(this.url + `menus/${id}`);
  }
  reorderMenus(items: string[]) {
    return this._http.patch(this.url + `menus/reorder`, { items });
  }

  getRoleMenu(roleId: string) {
    return this._http.get(this.url + `role-menu/${roleId}`);
  }
  toggleRoleMenu(roleId: string, menuId: string, enabled: boolean) {
    return this._http.patch(this.url + `role-menu/toggle`, { roleId, menuId, enabled });
  }

  getRoles<T = any>() {
    return this._http.get<T>(`${this.url}role`);
  }

  updateRole(role: any) {
    return this._http.patch(this.url + `role`, role);
  }

  createRole(role: any) {
    return this._http.post(this.url + `role`, role);
  }

}
